module.exports = __webpack_public_path__ + "img/compras_publicas_prata.fe1e5246.png";